import React, { useEffect } from "react";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Input, Select, Space } from "antd";

function MedicationBlock({ index, data, onChange, onDelete, isEditMode }) {
  useEffect(() => {
    if (data?.dosage) {
      const match = data.dosage.match(/^(\d+)([a-zA-Z/]+)$/);
      if (match) {
        onChange("dosageValue", match[1]); // number part
        onChange("dosageUnit", match[2]); // unit part
      }
    }
  }, [data?.dosage]);

  const medicalstyles = `
          .medication-block {
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 1.5rem;
            margin-bottom: 2rem;
            background: #fff;
          }

          .block-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
          }

          .block-header h5 {
            font-size: 1.2rem;
            font-weight: 600;
          }

          .delete-btn {
            background: none;
            border: none;
            font-size: 1.2rem;
            color: #e74c3c;
            cursor: pointer;
          }

          .form-group {
            margin-bottom: 1rem;
          }

          label {
            display: block;
            font-weight: 500;
            margin-bottom: 0.4rem;
          }

          input[type="text"],
          input[type="number"],
          select,
          textarea {
            width: 100%;
            padding: 0.5rem 0.75rem;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 0.95rem;
          }

          textarea {
            resize: vertical;
            min-height: 80px;
          }

          .grid-2 {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
          }

          .grid-3 {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .input-with-icon {
            position: relative;
          }

          .input-with-icon input {
            padding-right: 2.2rem;
          }

          .input-with-icon .icon {
            position: absolute;
            top: 50%;
            right: 0.75rem;
            transform: translateY(-50%);
            color: #888;
          }

          .footer-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 1rem;
          }

          /* Toggle switch style */
          .switch {
            position: relative;
            display: inline-block;
            width: 44px;
            height: 24px;
            margin-right: 0.5rem;
          }

          .switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            transition: .4s;
            border-radius: 34px;
          }

          .slider:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: .4s;
            border-radius: 50%;
          }

          input:checked + .slider {
            background-color: #4caf50;
          }

          input:checked + .slider:before {
            transform: translateX(20px);
          }

          .slider.round {
            border-radius: 34px;
          }
            .grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
        `;
  return (
    <>
      <style>{medicalstyles}</style>
      <div className="medication-block">
        <div className="block-header">
          <h5>Medication #{index}</h5>
          <button
            className="delete-btn"
            title="Remove Medication"
            onClick={() => onDelete(index)}
          >
            <MdOutlineDeleteOutline color={"red"} />
          </button>
        </div>



        <div className="grid-2">
          <div className="form-group">
            <label>Medication Name</label>
            <div className="input-with-icon">
              <input
                type="text"
                name="medicationName"
                autoComplete="medicationName"
                value={data.medicationName}
                onChange={(e) => onChange("medicationName", e.target.value)}
                placeholder="Select medication..."
              />
            </div>
          </div>
          <div className="form-group">
            
            <label>Route</label>
            <select
              value={data.route}
              onChange={(e) => onChange("route", e.target.value)}
            >
              <option>Oral</option>
              <option>Oral</option>
              <option>Intravenous</option>
              <option>Topical</option>
              <option>Inhalation</option>
              <option>Subcutaneous</option>
              <option>Intramuscular</option>
              <option>Transdermal</option>
              <option>Rectal</option>
              <option>Ophthalmic</option>
              <option>Buccal</option>
            </select>
          </div>



        </div>

        <div className="grid-4">
          <div className="form-group">
            <label style={{ marginTop: 5 }}>Dosage</label>
            <Space.Compact style={{ width: "100%", height: "43px" }} size="large">
              <Input
                type="number"
                size="large"
                placeholder="dosage..."
                value={data?.dosageValue ?? ""}
                onChange={(e) => {
                  const val = e.target.value;
                  onChange("dosageValue", val);
                  onChange("dosage", `${val}${data?.dosageUnit || "mg"}`); // send full to backend
                }}
              />

              <Select
                size="large"
                style={{ width: 110, height: "43px" }}
                value={data?.dosageUnit ?? "mg"}
                onChange={(v) => {
                  onChange("dosageUnit", v);
                  onChange("dosage", `${data?.dosageValue || ""}${v}`); // send full to backend
                }}
                options={[
                  { value: "mg", label: "mg" },
                  { value: "ml", label: "ml" },
                  { value: "mg/ml", label: "mg/ml" },
                  { value: "cm", label: "cm" },
                  { value: "%", label: "%" },
                ]}
              />
            </Space.Compact>
          </div>
          <div className="form-group">
            <label>Frequency</label>
            <select
              value={data.frequency}
              onChange={(e) => onChange("frequency", e.target.value)}
            >
              <option>Select frequency</option>
              <option>Once daily</option>
              <option>Twice daily</option>
              <option>Thrice daily</option>
              <option>Every 6 hours</option>
              <option>Every 8 hours</option>
              <option>Before meals</option>
              <option>After meals</option>
              <option>At bedtime</option>
              <option>As needed</option>
              <option>Weekly</option>
            </select>
          </div>
          <div className="form-group">
            <label>Duration</label>
            <input
              type="number"
              placeholder="30"
              value={data.duration}
              onChange={(e) => onChange("duration", e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <select
              value={data.durationUnit}
              onChange={(e) => onChange("durationUnit", e.target.value)}
            >
              <option>Days</option>
              <option>Weeks</option>
              <option>Months</option>
            </select>
          </div>
        </div>

        {/* <div className="form-group">
          <label>Special Instructions</label>
          <textarea
            placeholder="Enter any special instructions for this medication"
            value={data.specialInstructions}
            onChange={(e) => onChange("specialInstructions", e.target.value)}
          />
        </div> */}

        {/* <div className="footer-row">
          <div className="toggle-group">
            <label className="switch">
              <input
                type="checkbox"
                checked={data.allowRefills}
                onChange={(e) => onChange("allowRefills", e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
            <span>Allow Refills</span>
          </div>
          <div className="form-group">
            <label>Number of Refills:</label>
            <input
              type="number"
              value={data.numberOfRefills}
              onChange={(e) => onChange("numberOfRefills", e.target.value)}
              disabled={!data.allowRefills}
            />
          </div>
        </div> */}
      </div>
    </>
  );
}
export default MedicationBlock;
